"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 *
 * @class MultipleParameterCacheKey
 *
 * @classdesc
 * cache key used when there are multiple standard parameters
 */
var MultipleParameterCacheKey = function () {
  function MultipleParameterCacheKey(key) {
    _classCallCheck(this, MultipleParameterCacheKey);

    this.isMultiParamKey = true;
    this.key = null;
    this.size = 0;

    this.key = key;
    this.size = key.length;

    return this;
  }

  /**
   * @function matches
   * @memberof MultipleParameterCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance
   *
   * @param {Array<*>} key the key to test
   * @param {boolean} isMultiParamKey is the key a multi-parameter key
   * @returns {boolean} does the key passed match that in the instance
   */
  MultipleParameterCacheKey.prototype.matches = function matches(key, isMultiParamKey) {
    if (!isMultiParamKey || key.length !== this.size) {
      return false;
    }

    var index = 0;

    while (index < this.size) {
      if (key[index] !== this.key[index]) {
        return false;
      }

      index++;
    }

    return true;
  };

  /**
   * @function matchesCustom
   * @memberof SingleParameterCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance based on the custom equality function passed
   *
   * @param {Array<*>} key the key to test
   * @param {boolean} isMultiParamKey is the key a multi-parameter key
   * @param {function} isEqual method to compare equality of the keys
   * @returns {boolean} does the key passed match that in the instance
   */


  MultipleParameterCacheKey.prototype.matchesCustom = function matchesCustom(key, isMultiParamKey, isEqual) {
    return isMultiParamKey && isEqual(key, this.key);
  };

  return MultipleParameterCacheKey;
}();

exports.default = MultipleParameterCacheKey;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/moize/lib/MultipleParameterCacheKey.js
// module id = ./node_modules/moize/lib/MultipleParameterCacheKey.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000